import { createFileRoute } from "@tanstack/react-router";
import { cityServiceHead } from "../lib/route-head";
import { CityServicePage } from "../components/city-service-page";
import { getCityService } from "../data/city-services";


export const Route = createFileRoute("/vinyl-siding-cleaning-guilderland-ny")({
  loader: async () => {
    const c = (await import("../data/city-services")).getCityService("vinyl-siding-cleaning-guilderland-ny")!;
    return { meta: c.meta, heroImage: c.heroImage, service: c.service, city: c.city, faqs: c.faqs };
  },
  head: ({ loaderData }) => cityServiceHead("vinyl-siding-cleaning-guilderland-ny", "vinyl-siding-cleaning", loaderData),
  component: RouteComponent,
});

function RouteComponent() {
  return <CityServicePage content={getCityService("vinyl-siding-cleaning-guilderland-ny")!} />;
}
